module.exports = __webpack_public_path__ + "static/img/7-6.c53b78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-6.png
// module id = PCNr
// module chunks = 25